import Api from "../..";
import TransmedFormSection, {
  TransmedFormSectionInput,
} from "../../../dtos/transmed/process/form/section";
import transform from "../../../service/transform";

export default class TransmedFormSectionApi extends Api {
  constructor() {
    super("transmed/form/section");
  }

  public async get(): Promise<TransmedFormSection[]> {
    const data = (await super.get()).data;
    if (!Array.isArray(data))
      throw new TypeError("OutputTransmedFormSection entry list is not an array.");

    return await Promise.all(
      data.map(async (value) => await transform(TransmedFormSection)(value))
    );
  }

  public async post(
    data: TransmedFormSectionInput
  ): Promise<TransmedFormSection> {
    return await transform(TransmedFormSection)((await super.post(data)).data);
  }

  public async put(
    id: string,
    data: TransmedFormSectionInput
  ): Promise<TransmedFormSection> {
    return await transform(TransmedFormSection)(
      (
        await super.put(id, data)
      ).data
    );
  }

  public async delete(id: string): Promise<void> {
    await super.delete(id);
  }
}
